<template>
  <div id="formMatch">
    <Topbar @action="fnAction"></Topbar>
    <v-container class="center" v-if="loaded">
      <v-layout row wrap class="section-container" id="basic">
        <v-flex xs12 class="item">
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-layout row wrap>
                <!-- <v-flex xs12 class="name">{{ $t( "basic_info" ) }}</v-flex> -->
                <div style="width:100%;height:auto;display:contents;">
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.category' | i18n"
                      :value="match['category'] | checkParam"
                      disabled
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.group' | i18n"
                      :value="match['group'] | i18n"
                      disabled
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.name' | i18n"
                      :value="match['name'] | checkParam"
                      @change="v => (match.name = v)"
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-select
                      v-model="match.status"
                      :items="status_match"
                      :label="'params.status' | i18n"
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs2 md1 class="item">
                    <v-img
                      class="status-icon"
                      v-if="match['local_team']"
                      :src="match['local_team'].shield"
                    ></v-img>
                  </v-flex>
                  <v-flex xs4 md4 class="item">
                    <v-text-field
                      v-if="match['local_team']"
                      :label="'params.local_team' | i18n"
                      :value="match['local_team'].name | checkParam"
                      disabled
                      class="upper"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs2 md1 class="item">
                    <v-text-field
                      v-if="match['local_team']"
                      :label="'miccamps.stats.goals' | i18n"
                      :value="
                        ((match.local_goals ? match.local_goals : '-') +
                          (match.local_penalti_goals
                            ? '(' + match.local_penalti_goals + ')'
                            : ''))
                          | checkParam
                      "
                      class="upper"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs2 md1 class="item">
                    <v-text-field
                      v-if="match['away_team']"
                      :label="'miccamps.stats.goals' | i18n"
                      :value="
                        ((match.away_goals ? match.away_goals : '-') +
                          (match.away_penalti_goals
                            ? '(' + match.away_penalti_goals + ')'
                            : ''))
                          | checkParam
                      "
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 md4 class="item" v-if="match['away_team']">
                    <v-text-field
                      :label="'params.away_team' | i18n"
                      :value="match['away_team'].name | checkParam"
                      disabled
                      class="upper"
                    ></v-text-field>
                    <!-- disabled param falta -->
                  </v-flex>
                  <v-flex xs2 md1 class="item">
                    <v-img
                      class="status-icon"
                      v-if="match['away_team']"
                      :src="match['away_team'].shield"
                    ></v-img>
                  </v-flex>
                  <template>
                    <v-flex xs6 md6 class="item">
                      <v-select
                        id="team"
                        :no-data-text="$t('errors.write_3_characters')"
                        v-model="team_id_local"
                        :label="$t('params.local_team')"
                        :items="teams"
                        autocomplete
                      ></v-select>
                    </v-flex>
                    <v-flex xs6 md6 class="item">
                      <v-select
                        id="team"
                        :no-data-text="$t('errors.write_3_characters')"
                        v-model="team_id_visitant"
                        :label="$t('params.away_team')"
                        :items="teams"
                        autocomplete
                      ></v-select>
                    </v-flex>
                  </template>

                  <v-flex xs6 md6 class="item">
                    <v-menu
                      v-model="dialog_date"
                      autocomplete="new-text"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          prepend-icon="event"
                          v-model="match.parsedDate"
                          :label="$t('params.date')"
                          @click:prepend="dialog_date = true"
                          @click="dialog_date = true"
                          :placeholder="'DD/MM/YYYY'"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="match.date"
                        color="blue-grey lighten-2"
                        @input="(dialog_date = false), formatDate()"
                        :first-day-of-week="1"
                        locale="ca"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>

                  <v-flex xs6 md6 class="item">
                    <v-menu
                      ref="menu"
                      v-model="dialog_hour"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="time"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          prepend-icon="access_time"
                          v-model="match.hour"
                          :label="$t('params.hour')"
                          @click:prepend="dialog_hour = true"
                          @click="dialog_hour = true"
                          :placeholder="'HH:MM'"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="dialog_hour"
                        format="24hr"
                        color="blue-grey lighten-2"
                        v-model="match.hour"
                        full-width
                        @click:minute="$refs.menu.save(time)"
                        :rules="[value => !!value || $t('rules.required')]"
                      ></v-time-picker>
                    </v-menu>
                  </v-flex>

                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.referee_name' | i18n"
                      :value="match['referee_name'] | checkParam"
                      @change="v => (match.referee_name = v)"
                      class="upper"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 md6 class="item">
                    <v-text-field
                      :label="'params.referee_phone' | i18n"
                      :value="match['referee_phone'] | checkParam"
                      @change="v => (match.referee_phone = v)"
                      class="upper"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 md12 class="item">
                    <v-autocomplete
                      v-model="match.facility_id"
                      :items="facilities"
                      clearable
                      hide-details
                      hide-selected
                      label="Introdueix el nom del terreny de joc"
                    >
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 md12 class="item">
                    <v-text-field
                      :label="'params.streaming' | i18n"
                      :value="match['streaming'] | checkParam"
                      @change="v => (match.streaming = v)"
                    ></v-text-field>
                  </v-flex>
                </div>
              </v-layout>
            </v-container>
          </v-form>
        </v-flex>
      </v-layout>

      <v-layout
        row
        wrap
        class="section-container"
        v-if="match.status > 1"
        id="basic"
      >
        <v-flex xs12 class="name">Esdeveniments del partit</v-flex>
        <v-flex xs12 class="clear"
          ><div class="clear" style="height: 25px"></div
        ></v-flex>
        <template v-if="loaded">
          <v-flex
            xs12
            v-for="(event, index) in filteredEventUniformsAndReady"
            :key="event.id || `${event.type}-${index}`"
            style=""
          >
            <v-flex
              xs12
              v-if="event.type == 'uniforms'"
              style="margin: 10px 0; display: flex"
            >
              <v-flex style="display: inline" xs6>
                <Equipment
                  :equipment="getUniform(match.local_team_id)"
                  :number="1"
                  :is_preview="true"
                />
              </v-flex>
              <v-flex style="display: inline" xs6>
                <Equipment
                  :equipment="getUniform(match.away_team_id)"
                  :number="1"
                  :is_preview="true"
                />
              </v-flex>
            </v-flex>

            <v-flex
              xs12
              v-else-if="event.type == 'ready'"
              style="margin: 10px 0; display: flex"
            >
              <v-flex style="display: inline" xs6>
                <Headline
                  :team="{ ...match.local_team }"
                  :preFilled="{ ...getStarters(match.local_team_id) }"
                  :position="'left'"
                />
              </v-flex>
              <v-flex style="display: inline" xs6>
                <Headline
                  :team="{ ...match.away_team }"
                  :preFilled="{ ...getStarters(match.away_team_id) }"
                  :position="'right'"
                />
              </v-flex>
            </v-flex>
          </v-flex>

          <!-- Add create event button here -->
          <v-flex xs12 style="margin: 10px 0; text-align: left">
            <v-btn
              dark
              :style="{ backgroundColor: '#ffc107' }"
              @click="showCreateEventDialog = true"
              class="black--text"
            >
              <v-icon left>add</v-icon>
              {{ 'Crear Esdeveniment' || $t('miccamps.match_actions.create_event') }}
            </v-btn>
          </v-flex>

          <v-flex
            xs12
            v-for="(event, index) in filteredMatchEvents"
            :key="event.id || `${event.type}-${index}`"
            style="margin: 10px 0"
          >
            <MatchEvent
              :event="event"
              :match-teams="matchTeams"
              :team="getTeamByEvent(event)"
              :isEditingEvent="isEditingEvent"
              :showEditDialog="editingEventId === event.id"
              :showDeleteDialog="deletingEventId === event.id"
              :showRestoreDialog="restoringEventId === event.id"
              :showCreateEventDialog="showCreateEventDialog"
              @edit-event="editEvent"
              @delete-event="deleteEvent"
              @restore-event="restoreEvent"
              @open-edit="editingEventId = event.id"
              @open-delete="deletingEventId = event.id"
              @open-restore="restoringEventId = event.id"
              @close-dialogs="resetDialogs"
            />
          </v-flex>
        </template>

      </v-layout>
    </v-container>
    <CreateEventDialog
      :value="showCreateEventDialog"
      :loading="isEditingEvent"
      :match-teams="matchTeams"
      @confirm="onCreateEventConfirm"
      @input="showCreateEventDialog = $event"
      ref="createEventDialog"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import Topbar from "@/components/ui/Topbar";
import Equipment from "@/components/ui/Equipment";
import Headline from "@/components/ui/Headline.vue";
import MatchEvent from "@/components/ui/MatchEvent";
import CreateEventDialog from "@/components/ui/CreateEventDialog";

export default {
  name: "MatchForm",
  components: {
    Topbar,
    Equipment,
    Headline,
    MatchEvent,
    CreateEventDialog
  },
  props: { page: String, action: String },
  data() {
    return {
      match: { document_type: "1", status: 1 },
      valid: false,
      dialog_date: false,
      dialog_hour: false,
      time: null,
      team_id_local: "",
      team_id_visitant: "",
      status_match: [
        { value: 1, text: i18n.t("miccamps.status.no_started") },
        { value: 2, text: i18n.t("miccamps.status.uniforms") },
        { value: 3, text: i18n.t("miccamps.status.players") },
        { value: 4, text: i18n.t("miccamps.status.first_half") },
        { value: 5, text: i18n.t("miccamps.status.half_time") },
        { value: 6, text: i18n.t("miccamps.status.second_half") },
        { value: 7, text: i18n.t("miccamps.status.penalties") },
        { value: 8, text: i18n.t("miccamps.status.end") },
        { value: 9, text: i18n.t("miccamps.status.closed") }
      ],
      loaded: false,
      editingEventId: null,
      deletingEventId: null,
      restoringEventId: null,
      isEditingEvent: false,
      showCreateEventDialog: false
    }
  },
  computed: {
    matchTeams () {
      return {
        home: this.match.local_team,
        away: this.match.away_team
      }
    },
    facilities () {
      var facilities = this.$store.getters["facilitys/getList"]()
      var aFacilities = []
      facilities.forEach((facility) => {
        aFacilities.push({
          text: facility.name,
          value: facility.id
        })
      })

      return aFacilities
    },
    event () {
      return { ...this.$store.getters["events/getCurrentEvent"]() }
    },
    teams: function () {
      var teams = this.$store.getters["teams/getList"]()
      var aTeams = []
      var eventID = this.event
      if (eventID != null) {
        for (var i in teams) {
          var t = teams[i]
          if (
            t.event.id == eventID.id &&
            t.status == "6" &&
            t.category.id == this.match.category_id
          ) {
            aTeams.push({ text: t.name, value: t.id })
          }
        }
      }

      aTeams.sort(function (t1, t2) {
        if (t1.name < t2.name) return 1
        return -1
      })

      aTeams.unshift({ text: "No assignar equip", value: -1 })

      return aTeams
    },
    filteredEventUniformsAndReady () {
      if (!this.match || !this.match.log || !this.match.log.events) return []
      let eventsUniforms = Object.values(this.match.log.events).filter(e =>
        ['uniforms'].includes(e.type)
      )
      let eventsReady = Object.values(this.match.log.events).filter(e =>
        ['ready'].includes(e.type)
      )
      // Get Last event of each type
      let lastEventUniforms = eventsUniforms.sort((a, b) => new Date(b.date) - new Date(a.date))[0]
      let lastEventReady = eventsReady.sort((a, b) => new Date(b.date) - new Date(a.date))[0]
      return [lastEventUniforms, lastEventReady]
    },

    filteredMatchEvents () {
      if (!this.match || !this.match.log || !this.match.log.events) return []
      let events = Object.values(this.match.log.events)
        .filter(e => !['uniforms', 'ready'].includes(e.type))
        .reverse()
      let eventsReady = Object.values(this.match.log.events).filter(e =>
        ['ready'].includes(e.type)
      )
      let lastEventReady = eventsReady.sort((a, b) => new Date(b.date) - new Date(a.date))[0]
      // Add lastEventReady to events at first position
      events.unshift(lastEventReady)
      return events
    }
  },
  watch: {
    // call again the method if the route changes
    $route: "loadDataPage"
  },
  created () {
    this.loadDataPage()
  },
  methods: {
    resetDialogs () {
      this.editingEventId = null
      this.deletingEventId = null
      this.restoringEventId = null
    },
    async restoreEvent (event) {
      console.log('Restoring event:', event)
      const eventId = event.id
      const matchId = this.$route.params.id
      this.isEditingEvent = true

      try {
        await this.$store.dispatch('matches/restoreEvent', {
          matchId,
          eventId
        })

        this.resetDialogs()
        this.loadDataPage(true)
      } catch (error) {
        console.log('notify', { type: 'error', message: 'Failed to restore event' })
      } finally {
        this.isEditingEvent = false
      }
    },
    async editEvent (originalEvent) {
      if(typeof originalEvent === 'string'){
        originalEvent = JSON.parse(originalEvent)
      }
      const eventId = originalEvent.id
      const matchId = this.$route.params.id
      this.isEditingEvent = true

      try {
        console.log('Editing event:', originalEvent)
        const event = { ...originalEvent } // Create a shallow copy
        event.data = JSON.stringify(event.data) // Ensure data is in the correct format
        const data = JSON.stringify(event)
        const payload = {
          event: data
        }

        await this.$store.dispatch('matches/editEvent', {
          matchId,
          eventId,
          payload
        })
        this.resetDialogs()
        this.loadDataPage(true)
      } catch (error) {
        console.log('notify', { type: 'error', message: 'Failed to update event' })
      } finally {
        this.isEditingEvent = false
      }
    },

    async deleteEvent (event) {
      const eventId = event.id
      const matchId = this.$route.params.id
      this.isEditingEvent = true

      try {
        await this.$store.dispatch('matches/deleteEvent', {
          matchId,
          eventId
        })

        this.resetDialogs()
        this.loadDataPage(true)
      } catch (error) {
        console.log('notify', { type: 'error', message: 'Failed to delete event' })
      } finally {
        this.isEditingEvent = false
      }
    },

    async onCreateEventConfirm (events) {
      const matchId = this.$route.params.id
      const thismacth = { ...this.$store.getters['competition/matchs/getList'](matchId) }
      this.isEditingEvent = true

      try {
        const nextEvent = thismacth.log.next_event
        const payload = {
          rev: nextEvent,
          events
        }

        await this.$store.dispatch('matches/addEvent', {
          matchId,
          payload
        })
        this.resetDialogs()
        this.loadDataPage(true)
      } catch (error) {
        console.log('notify', { type: 'error', message: 'Failed to update event' })
      } finally {
        this.isEditingEvent = false
        this.showCreateEventDialog = false
        this.$refs.createEventDialog.resetForm()
      }
    },

    loadDataPage (force = false) {
      this.$store.commit("setTopbarActionsVisible", true)
      this.$store.commit("setMenuVisible", true)

      var id = this.$route.params.id
      var self = this

      if (id !== undefined && (!this.loaded || force)) {
        this.$overlay.loading()

        this.$store
          .dispatch("competition/matchs/load_by_id", {
            event: this.$store.getters["events/getCurrentEvent"]().id,
            id: id
          })
          .then(function () {
            const newMatch = {
              ...self.$store.getters["competition/matchs/getList"](id)
            }

            // deep clone to ensure Vue detects the change
            if (newMatch.log && newMatch.log.events) {
              newMatch.log.events = JSON.parse(JSON.stringify(newMatch.log.events))
            }

            self.match = {}
            self.$nextTick(() => {
              self.match = newMatch
              
              if (self.match.date != null) {
                self.formatDate();
                self.match.hour = self.match.date.split(" ")[1]
                self.match.date = self.match.date.split(" ")[0]
              } else {
                self.match.hour = ""
                self.match.date = ""
                self.parsedDate = ""
              }
            })

            // Goals + event parsing logic...

            self.$store
              .dispatch("teams/loadList", {
                event: self.$store.getters["events/getCurrentEvent"]().id,
                page_options: { num_items: -1, page: -1 },
                filters: { status: 6 }
              })
              .then(function () {
                self.loaded = true
                self.$overlay.hide()
              })
          })
      } else {
        this.$overlay.hide()
      }
    },

    getUniform (team_id) {
      var self = this
      for (var k in self.match.log.events) {
        let event = self.match.log.events[k]
        if (event.type == "uniforms") {
          let data = event.data
          if (data[team_id]) return data[team_id]
        }
      }

      return false;
    },

    getStarters (team_id) {
      var self = this
      for (var k in self.match.log.events) {
        let event = self.match.log.events[k]
        if (event.type == "ready") {
          let data = event.data
          if (data.prefilled[team_id]) {
            data = data.prefilled[team_id]
            var team =
              self.match.local_team_id == team_id
                ? self.match.local_team
                : self.match.away_team
            data.no_starters = []
            for (var k in team.players) {
              if (!data.starters.includes(k) && !data.notlisted.includes(k)) {
                data.no_starters.push(k)
              }
            }
          }
          return data
        }
      }

      return false
    },

    getOptions (options, filter, bFirstEmpty) {
      var bFirstEmpty =
        typeof bFirstEmpty === "undefined" ? false : bFirstEmpty
      if (typeof options === "string") {
        var aOptions = []
        // console.log( options );
        // console.log( filter );
        if (typeof filter.params !== "undefined") {
          var values = this.$store.getters[options](filter.params)
        } else {
          var values = this.$store.getters[options]()
        }
        if (bFirstEmpty) {
          aOptions.push({ value: -1, text: i18n.t(filter.label) })
        }
        for (var i in values) {
          var value = values[i]
          name =
            typeof filter.translate === "undefined" || filter.translate
              ? i18n.t(value.name)
              : value.name
          aOptions.push({ value: value.id, text: name })
        }

        return aOptions
      } else {
        return options
      }
    },

    loadAutocomplete (event, param) {
      this.param_autocomplete = param.param
      clearTimeout(this.toAutoComplete)
      var self = this
      this.toAutoComplete = setTimeout(function () {
        if (event.target.value.length > 2) {
          self.$store
            .dispatch(param.action, event.target.value)
            .then(function () {
              var aResults = self.$store.getters[param.getter]()
              var aResult = []
              for (var k in aResults) {
                var result = aResults[k]
                aResult.push({ text: result.name, value: result.id })
              }

              self.cAutoComplete = aResult
            })
        }
      }, 200)
    },

    fnAction (emit) {
      if (typeof emit.action === "undefined" || emit.action == null) return
      switch (emit.action) {
        case "save":
          this.fnSave(emit.params)
          break
        case "go_to_camps":
          this.fnGoToCamps(emit.params)
          break
      }
    },

    fnSave () {
      if (this.$refs.form.validate()) {
        // TODO En el caso de que haya seleccionado el autocomplete con valor añadirlo al uploadmatch como local_team_id y away_team_id
        var uploadMatch = {
          date: this.match.date + " " + this.match.hour,
          facility_id:
            this.match.facility_id == undefined ? null : this.match.facility_id,
          referee_name: this.match.referee_name,
          referee_phone: this.match.referee_phone,
          name: this.match.name,
          local_goals: this.match.local_goals,
          away_goals: this.match.away_goals,
          streaming: this.match.streaming,
          status: this.match.status
        };
        if (this.team_id_local !== "") {
          uploadMatch.local_team_id = this.team_id_local
        }
        if (this.team_id_visitant !== "") {
          uploadMatch.away_team_id = this.team_id_visitant
        }

        var self = this
        this.$store
          .dispatch("competition/matchs/editMatch", {
            id: this.$route.params.id,
            data: uploadMatch
          })
          .then(function () {
            var event = self.$store.getters["events/getCurrentEvent"]()
            self.$router.push({
              name: "event_competition_matchs",
              params: {
                event: self.$root
                  .formatEventUrl(event.name, event.edition)
                  .replace("/event/", "")
              }
            })
          })
      } else {
        this.$popup.alert({
          message: i18n.t("exists_error_on_form"),
          btnSuccess: i18n.t("accept")
        })
      }
    },

    fnGoToCamps () {
      if (this.match["local_team"] && this.match["away_team"]) {
        window.open(
          process.env.VUE_APP_CAMPS_URL +
            (this.match.status < 3 ? "pre/" : "manager/") +
            this.$route.params.id
        )
      } else {
        this.$popup.alert({
          message: i18n.t("El partit no té equips assignats"),
          btnSuccess: i18n.t("accept")
        })
      }
    },

    formatDate () {
      this.match.parsedDate = moment(this.match.date).format("DD/MM/YYYY")
    },

    getTeamByEvent(event) {
      console.log("getTeamByEvent", event)
      var data = event.data
      if (data.team !== "undefined") {
        var team = data.team == "home" ? "local" : data.team
        return this.match[team + "_team"]
      }
      return false
    }
  },
  filters: {
    checkParam (value) {
      return value != null ? value : ''
    }
  },
  watch: {
    "match.name": {
      handler (val) {
        this.match.name = val
      },
      deep: true
    },
    "match.referee_name": {
      handler (val) {
        this.match.referee_name = val
      },
      deep: true
    },
    "match.referee_phone": {
      handler (val) {
        this.match.referee_phone = val
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#formMatch {
  width: 100%;
  display: inline-block;
  height: 100%;
  overflow-y: auto;

  .container {
    width: 80%;
    width: calc(100% - 350px);
    padding: 0px;

    &.center {
      margin: 0 auto;
    }

    .name {
      font-size: 22px;
      border-bottom: 2px solid;
      cursor: pointer;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;

      &.hidden {
        &::after {
          transform: rotate(180deg);
          transition-duration: 0.2s;
        }
      }
    }

    .clear {
    }

    .role {
      padding: 0;

      .container {
        margin: 0;
        width: 100%;

        .name {
          font-size: 18px;
          color: #685f5f;
        }
      }
    }

    .section-container {
      padding: 20px;

      &#basic {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#acta {
        background-color: #ccc;
        @include box-shadow($h: 0px, $v: 3px, $b: 8px, $s: 0px, $c: #00000011);
      }
      &#notes {
        background-color: $complem-color-light;
      }
      &#teams {
        background-color: #fff;
        @include box-shadow($h: 0px, $v: -3px, $b: 8px, $s: 0px, $c: #00000011);
      }

      .item.flex {
        padding: 0 20px;

        .image {
          // width: 40%;
          float: left;
          padding: 0 40px;

          img,
          .addthumb {
            width: 150px;
            border: 1px solid #ccc;
            height: 150px;
            position: relative;
            cursor: pointer;
          }

          .addthumb div {
            width: 100%;
            display: block;
            top: 35%;
            position: absolute;
            text-align: center;
          }
          .addthumb .text {
            top: 60%;
          }
        }

        .name {
          position: relative;

          .remove {
            width: fit-content;
            float: right;
          }

          .add {
            background-image: url(/img/add_b.svg);
            background-size: 15px;
            background-repeat: no-repeat;
            background-position: left center;
            position: absolute;
            right: 0;
            top: 15px;
            padding-left: 20px;
            text-transform: none;
            font-weight: bold;
            cursor: pointer;
          }
        }

        .v-input:not(.v-input--radio-group) .v-input__slot {
          border: none;
          border-bottom: 2px solid rgba(0, 0, 0, 0.14);
          border-radius: 0;
          padding-left: 0;
        }

        .v-image {
          width: 50px;
        }

        label {
          text-transform: capitalize;
        }
        .v-input__prepend-inner {
          margin-top: 25px;
        }

        .v-input.upper input {
          text-transform: uppercase;
        }
      }

      .v-menu__content {
        position: fixed !important;
      }
      .v-select {
        label {
          text-transform: capitalize;
          top: 0px;
          padding-left: 0;
          font-size: 18px;
          /*display: none;*/
        }
      }
    }
  }
}
</style>
